export const JV_CHINA_RESTRICTED_COUNTRIES = ['CN', 'HK', 'MO'] as const;

export const JV_CHINA_RESTRICTED_COUNTRIES_SET = new Set<string>(
  JV_CHINA_RESTRICTED_COUNTRIES
);

export const isJVChinaRestrictedCountry = (country: string) =>
  JV_CHINA_RESTRICTED_COUNTRIES_SET.has(country);
